// Call statuses
export const COMPLETED_STATUS = "completed";
export const ANSWERED_STATUS = "answered";

// Call events
export const INCOMING_CALL_EVENT = "incomingCallEvent";
